import { Component, inject, signal } from '@angular/core';
import { Session } from '../../services/session';
import { Router, RouterLink } from '@angular/router';
import { UserService } from '../../services/user';
import { ApiEndpoints } from '../../core/api-endpoints';
import { IUser } from '../../interfaces/user';
import { FlashService } from '../../services/flash';
import { Helpers } from '../../utilities/helpers';

@Component({
  selector: 'app-admin-welcome',
  imports: [RouterLink],
  templateUrl: './admin-welcome.html',
  styleUrl: './admin-welcome.css',
})
export class AdminWelcome {
  constructor(
    private session: Session,
    private userService: UserService,
    private router: Router,
  ) {
    const token = this.session.getItem('token');

    if (this.session.decodeToken(token)?.role !== 'SUPER_ADMIN' || !token) {
      this.router.navigate(['/']);
      return;
    }

    this.userId = this.session.decodeToken(token)?.sub;

    if (this.userId) {
      this.getUser();
    }
  }

  protected userId?: string;
  protected user = signal<IUser | null>(null);
  protected readonly flashService = inject(FlashService);
  protected isLoading = signal<boolean>(false);
  protected readonly Helpers = Helpers;

  protected getUser(): void {
    this.isLoading.set(true);

    this.userService.getUserById(`${ApiEndpoints.url}/user/${this.userId}`).subscribe({
      next: (data) => {
        this.user.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        this.isLoading.set(false);
        this.flashService.failure(err?.error?.message ?? 'Failed to load user details');
      },
    });
  }
}
